import React from 'react';
import GenericButton from './GenericButton';
import { useSelector, useDispatch } from 'react-redux';
import { closeExitModal } from '../app/mainSlice';
import FocusTrap from 'focus-trap-react';

/**
 * @param props.isLastStep
 * @param props.isCartMode
 * @param props.handleContinue
 * @param props.handleSave
 * @param props.handleDiscard
 * @param props.isOpen
 */
const ExitModal = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const isExitModalOpen = useSelector(state => state.main.isExitModalOpen);

    const handleOutside = (event, element) => {
        if (amIclicked(event, element)) dispatch(closeExitModal());
    };

    const amIclicked = (e, element) => {
        e = e || event;
        let target = e.target || e.srcElement;
        if (target.id == element) return true;
        else return false;
    };

    if (!props.isOpen) return null;
    return (
        <FocusTrap active={isExitModalOpen}>
            <div
                className="exit-modal-container"
                id="exit-modal-out"
                onClick={e => handleOutside(e, 'exit-modal-out')}
            >
                <div className="exit-modal">
                    <div className="exit-title">{labels.exitTitle}</div>
                    <div className="exit-sub-title">{labels.exitSubTitle}</div>
                    <GenericButton
                        className="exit-continue-button filling-button"
                        handleClick={props.handleContinue}
                    >
                        {labels.continueEdit}
                    </GenericButton>
                    {props.isLastStep && !props.isCartMode && (
                        <GenericButton
                            className="exit-save-button border-button"
                            handleClick={props.handleSave}
                        >
                            {labels.saveEdit}
                        </GenericButton>
                    )}
                    <a
                        href="#"
                        className="exit-discard cursor-hand"
                        onClick={props.handleDiscard}
                        tabIndex="0"
                    >
                        {labels.discardChanges}
                    </a>
                </div>
            </div>
        </FocusTrap>
    );
};

export default ExitModal;
